import { render, staticRenderFns } from "./simple_layout.vue?vue&type=template&id=378b49c0&scoped=true&"
import script from "./simple_layout.vue?vue&type=script&lang=js&"
export * from "./simple_layout.vue?vue&type=script&lang=js&"
import style0 from "./simple_layout.vue?vue&type=style&index=0&id=378b49c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378b49c0",
  null
  
)

export default component.exports